import { render, staticRenderFns } from "./mixed.vue?vue&type=template&id=516bd0f1&scoped=true"
import script from "./mixed.vue?vue&type=script&lang=js"
export * from "./mixed.vue?vue&type=script&lang=js"
import style0 from "./mixed.vue?vue&type=style&index=0&id=516bd0f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516bd0f1",
  null
  
)

export default component.exports